import getPriceSuggestion from 'modules/emergencies/api/getPriceSuggestion';

export const priceSuggestionFetcher = async (args) => {
  const ticket_id = args[1];
  const priceSuggestionDTOString = args[2];
  if (priceSuggestionDTOString === null) return undefined;
  const priceSuggestionDTO = JSON.parse(priceSuggestionDTOString);
  return getPriceSuggestion({ id: ticket_id, priceSuggestionDTO });
};
